import React, { useContext, useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { Context } from "../../state/context";

export default function CategoriesSelect({ selectedItems, showLabel, onChange, onSave }) {
    const { state } = useContext(Context);

    const [categoriesOptions, setCategoryOptions] = useState(false);
    const [categories, setCategory] = useState(false);
    const [showSave, setShowSave] = useState(false);

    useEffect(() => {
        setCategory(selectedItems);
    }, [selectedItems]);

    useEffect(() => {
        const opt = state.categories.map((category) => {
            return {
                value: category.id,
                label: category.name
            };
        });
        setCategoryOptions(opt);
    }, [state.categories]);

    const handleChange = (values) => {
        if (!showSave) setShowSave(true);
        if (!values) values = [];
        onChange(values);
    }

    const handleSave = () => {
        const response = onSave();
        if (response) {
            setShowSave(false);
        }
    }

    return (
        <div className={`${onSave ? 'mb-4' : ''}`}>
            <div className={`${!onSave ? ((showLabel) ? 'mb-2' : '') : ''}`}>
                {showLabel && <h6 className='translation-section-title text-muted'>Add categories</h6>}
                {(categories && categoriesOptions) && <CreatableSelect className="cursor-pointer" closeMenuOnSelect={false} isMulti options={categoriesOptions} backspaceRemovesValue={false} defaultValue={categories} onChange={handleChange} />}
            </div>
            {onSave && <button className={`btn btn-mondly btn-blue mt-2 ${showSave ? '' : 'transparent'}`} disabled={!showSave} onClick={handleSave}>Save</button>}
        </div>
    )
}